import React from "react";
import { motion } from "framer-motion";


class End extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      //count: 0,
    };
  }

  render() {
    const { setScreen } = this.props;
    return (
      <motion.div
        className="flex flex-column items-center w-100 h-100 overflow-hidden"
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0 }}
        transition={{ ease: "easeOut", duration: 0.8 }}
      >
        End!
        <button
          onClick={() => {
            setScreen("intro");
          }}
        >
          Start again
        </button>
      </motion.div>
    );
  }
}

export default End;
